import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const TermsAndConditions: React.FC = () => {
  return (
    <div>
      <section className="relative pt-32 pb-12 bg-gradient-hero text-white overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute bottom-10 right-20 w-60 h-60 bg-accent rounded-full blur-3xl" />
        </div>
        <div className="container mx-auto relative z-10">
          <motion.div 
            initial={{ opacity: 0, y: -30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-3xl mx-auto text-center"
          >
            <h1 className="text-4xl md:text-5xl font-extrabold mb-6 font-display">Termini e Condizioni</h1>
            <p className="text-xl text-white/80">
              Condizioni generali di utilizzo del sito web e del servizio di consulenza Rinova Group
            </p>
          </motion.div>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto">
          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-4xl mx-auto bg-white p-8 md:p-12 rounded-2xl shadow-card border border-light-border/50"
          >
            <div className="prose prose-lg max-w-none prose-headings:font-display prose-headings:text-light-text prose-p:text-light-muted prose-li:text-light-muted prose-a:text-primary">
              <p className="text-sm text-light-muted italic">
                Ultimo aggiornamento: Gennaio 2026
              </p>

              <h2>Condizioni Generali di Utilizzo</h2>
              <p>
                I presenti Termini e Condizioni ("Termini") regolano l'accesso e l'utilizzo del sito web 
                rinovagroup.it ("Sito") e dei servizi offerti da Rinova Srl ("Società" o "Noi"). 
                L'utilizzo del Sito implica l'accettazione integrale dei presenti Termini.
              </p>

              <h3>1. Identificazione del Titolare</h3>
              <ul>
                <li><strong>Ragione sociale:</strong> Rinova Srl</li>
                <li><strong>Sede legale:</strong> Via Fratelli Bandiera 1, 88060 Montepaone (CZ), Italia</li>
                <li><strong>P.IVA:</strong> IT03994100794</li>
                <li><strong>Email:</strong> info@rinovagroup.it</li>
              </ul>

              <h3>2. Definizioni</h3>
              <ul>
                <li><strong>"Sito":</strong> il sito web rinovagroup.it e tutte le sue pagine</li>
                <li><strong>"Servizio":</strong> il servizio gratuito di consulenza e comparazione delle offerte per 
                energia, gas e internet offerto dalla Società</li>
                <li><strong>"Utente":</strong> qualsiasi persona fisica o giuridica che accede o utilizza il Sito</li>
                <li><strong>"Fornitore":</strong> le società terze che forniscono servizi di energia, gas o internet 
                le cui offerte sono oggetto di comparazione sul Sito</li>
                <li><strong>"Contenuti":</strong> tutti i testi, immagini, grafiche, loghi e materiali presenti sul Sito</li>
              </ul>

              <h3>3. Natura del Servizio</h3>
              <p>
                <strong>Rinova Srl offre un servizio gratuito di consulenza e comparazione delle offerte</strong> per 
                energia elettrica, gas naturale e connettività internet. È fondamentale comprendere che:
              </p>
              <ul>
                <li>Rinova Srl <strong>non è un fornitore diretto</strong> di energia, gas o servizi internet</li>
                <li>Rinova Srl opera come <strong>intermediario indipendente</strong> che facilita il confronto tra 
                le offerte disponibili sul mercato</li>
                <li>Il servizio di consulenza è <strong>completamente gratuito</strong> per l'Utente e non comporta 
                alcun costo o commissione a suo carico</li>
                <li>La consulenza fornita <strong>non implica alcun obbligo di sottoscrizione</strong> di contratti 
                con i Fornitori</li>
                <li>L'eventuale decisione di aderire a un'offerta è una <strong>scelta libera, autonoma e consapevole 
                dell'Utente</strong></li>
                <li>Le informazioni e le offerte presenti sul Sito hanno <strong>carattere puramente informativo</strong> 
                e possono essere soggette a variazioni da parte dei Fornitori</li>
              </ul>

              <h3>4. Accesso e Utilizzo del Sito</h3>
              <p>
                L'accesso al Sito è consentito su base temporanea. La Società si riserva il diritto di sospendere, 
                modificare o interrompere la disponibilità del Sito, in tutto o in parte, senza preavviso e senza 
                che ciò generi alcun diritto di risarcimento in capo all'Utente.
              </p>
              <p>L'Utente si impegna a non:</p>
              <ul>
                <li>Utilizzare il Sito per scopi illeciti, fraudolenti o non conformi ai presenti Termini</li>
                <li>Compromettere la sicurezza, la disponibilità o il funzionamento del Sito</li>
                <li>Trasmettere materiale pubblicitario non autorizzato (spam) o codice dannoso</li>
                <li>Raccogliere dati personali di altri utenti senza autorizzazione</li>
                <li>Tentare di accedere a sezioni riservate del Sito senza autorizzazione</li>
              </ul>

              <h3>5. Informazioni e Offerte</h3>
              <p>
                Le informazioni, i prezzi e le offerte presentati sul Sito sono forniti a <strong>titolo puramente 
                indicativo e informativo</strong>. La Società si impegna a mantenere le informazioni il più aggiornate 
                possibile, ma non può garantire la completezza, l'accuratezza o l'attualità di tutte le informazioni 
                pubblicate.
              </p>
              <p>
                <strong>I prezzi e le condizioni delle offerte possono variare</strong> in qualsiasi momento su 
                decisione dei Fornitori. Per le condizioni contrattuali definitive e vincolanti, l'Utente deve sempre 
                fare riferimento alla documentazione ufficiale del Fornitore prescelto.
              </p>

              <h3>6. Processo di Adesione alle Offerte</h3>
              <p>
                Qualora l'Utente decida, in piena autonomia e senza alcun obbligo, di aderire a un'offerta:
              </p>
              <ul>
                <li>Il contratto sarà stipulato direttamente tra l'Utente e il Fornitore prescelto</li>
                <li>Rinova Srl non è parte del contratto tra l'Utente e il Fornitore</li>
                <li>Le condizioni contrattuali sono quelle definite dal Fornitore nella propria documentazione ufficiale</li>
                <li>L'Utente avrà diritto di recesso nei termini e modi previsti dalla legge e dal contratto con il Fornitore</li>
              </ul>

              <h3>7. Proprietà Intellettuale</h3>
              <p>
                Tutti i Contenuti presenti sul Sito, inclusi testi, grafiche, loghi, icone, immagini e software, 
                sono di proprietà di Rinova Srl o dei rispettivi licenzianti e sono protetti dalle leggi italiane 
                ed europee sul diritto d'autore e sulla proprietà intellettuale.
              </p>
              <p>
                È vietata la riproduzione, distribuzione, modifica o qualsiasi altro uso non autorizzato 
                dei Contenuti senza il preventivo consenso scritto della Società.
              </p>

              <h3>8. Esclusione e Limitazione di Responsabilità</h3>
              <p>
                Nella misura massima consentita dalla legge applicabile:
              </p>
              <ul>
                <li>La Società non garantisce che le informazioni sul Sito siano sempre accurate, complete e aggiornate</li>
                <li>La Società non è responsabile per eventuali danni derivanti dall'utilizzo delle informazioni 
                presenti sul Sito, incluse decisioni di acquisto basate su tali informazioni</li>
                <li>La Società non è responsabile per i servizi forniti da terze parti (Fornitori) con cui 
                l'Utente dovesse stipulare un contratto</li>
                <li>La Società non è responsabile per eventuali interruzioni, errori o malfunzionamenti del Sito</li>
              </ul>

              <h3>9. Link a Siti Terzi</h3>
              <p>
                Il Sito può contenere link a siti web di terze parti. La Società non ha alcun controllo 
                sui contenuti di tali siti e non è responsabile per le informazioni, i prodotti o i servizi 
                offerti da terze parti.
              </p>

              <h3>10. Privacy e Cookie</h3>
              <p>
                Il trattamento dei dati personali è regolato dalla nostra{' '}
                <Link to="/privacy-policy" className="text-primary hover:underline">Informativa sulla Privacy</Link>. 
                L'utilizzo dei cookie è descritto nella nostra{' '}
                <Link to="/cookie-policy" className="text-primary hover:underline">Cookie Policy</Link>.
              </p>

              <h3>11. Indennizzo</h3>
              <p>
                L'Utente si impegna a manlevare e tenere indenne Rinova Srl, i suoi amministratori, dipendenti 
                e collaboratori da qualsiasi pretesa, responsabilità, danno, costo o spesa derivanti dalla 
                violazione dei presenti Termini o dall'uso improprio del Sito.
              </p>

              <h3>12. Modifiche ai Termini e Condizioni</h3>
              <p>
                La Società si riserva il diritto di modificare i presenti Termini in qualsiasi momento. 
                Le modifiche avranno effetto dalla data di pubblicazione sul Sito. L'uso continuato del Sito 
                dopo la pubblicazione delle modifiche costituisce accettazione delle stesse.
              </p>

              <h3>13. Nullità Parziale</h3>
              <p>
                Qualora una o più disposizioni dei presenti Termini siano ritenute nulle o inapplicabili, 
                le restanti disposizioni rimarranno pienamente valide ed efficaci.
              </p>

              <h3>14. Legge Applicabile e Foro Competente</h3>
              <p>
                I presenti Termini e Condizioni sono regolati dalla legge italiana. Per qualsiasi controversia 
                relativa all'interpretazione, validità o esecuzione dei presenti Termini, sarà competente in 
                via esclusiva il Tribunale di Catanzaro, fatte salve le norme inderogabili a tutela del consumatore 
                previste dal Codice del Consumo (D.Lgs. 206/2005).
              </p>
              <p>
                L'Utente consumatore ha inoltre la facoltà di ricorrere alla piattaforma ODR (Online Dispute Resolution) 
                dell'Unione Europea, accessibile all'indirizzo:{' '}
                <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">
                  https://ec.europa.eu/consumers/odr
                </a>
              </p>

              <h3>15. Contatti</h3>
              <p>Per qualsiasi domanda relativa ai presenti Termini e Condizioni:</p>
              <ul>
                <li><strong>Email:</strong> info@rinovagroup.it</li>
                <li><strong>Indirizzo postale:</strong> Rinova Srl, Via Fratelli Bandiera 1, 88060 Montepaone (CZ), Italia</li>
                <li><strong>P.IVA:</strong> IT03994100794</li>
              </ul>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default TermsAndConditions;
